import styled from 'styled-components';
import MuiButton from '@material-ui/core/Button';

export const StyledMuiButton = styled(MuiButton)`
  color: #fff;
  border-radius: 0;
  padding: 2px 5px;
  margin: 0 3px;

  .MuiButton-label {
    margin: 24px 15px 14px;
    padding-bottom: 8px;
    border-bottom: 2px solid transparent;
  }

  &.active .MuiButton-label {
    border-color: #99EEFF;
  }

  svg {
    color: #99EEFF;
    margin-right: 10px;
  }
`;
